import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "*",
      redirect: "/",
    },
    {
      path: "/",
      name: "PageView",
      component: (resolve) => require(["@/view/PageView"], resolve),
      children: [
        {
          path: "/",
          redirect: "/home",
        },
        {
          path: "/home",
          name: "home",
          component: (resolve) => require(["@/view/HomePage"], resolve),
          meta: {
            title: "首页",
          },
        },
        {
          path: "/software",
          name: "software",
          component: (resolve) => require(["@/view/Software"], resolve),
          meta: {
            title: "产品案例",
          },
          children: [
            {
              path: "/software",
              redirect: "/software/smartTown",
            },
            {
              path: "/software/smartTown",
              name: "software",
              component: (resolve) =>
                require(["@/view/Software_smartTown"], resolve),
              meta: {
                title: "产品案例丨虚拟仿真",
              },
            },
            {
              path: "/software/bigData",
              name: "software",
              component: (resolve) =>
                require(["@/view/Software_bigData"], resolve),
              meta: {
                title: "产品案例丨智慧平台",
              },
            },
            {
              path: "/software/digitalTwin",
              name: "software",
              component: (resolve) =>
                require(["@/view/Software_digitalTwin"], resolve),
              meta: {
                title: "产品案例丨数字孪生",
              },
            },
          ],
        },
        {
          path: "/service",
          name: "service",
          component: (resolve) => require(["@/view/Service"], resolve),
          meta: {
            title: "相关服务",
          },
        },
        {
          path: "/newsinformation",
          name: "newsinformation",
          component: (resolve) => require(["@/view/NewsInformation"], resolve),
          meta: {
            title: "新闻动态",
          },
        },
        {
          path: "/companyintroduction",
          name: "companyintroduction",
          component: (resolve) =>
            require(["@/view/CompanyIntroduction"], resolve),
          meta: {
            // title: "公司介绍",
            title: "关于我们",
          },
        },
        {
          path: "/jobchance",
          name: "jobchance",
          component: (resolve) => require(["@/view/JobChance"], resolve),
          meta: {
            title: "工作机会",
          },
        },
        {
          path: "/contactus",
          name: "contactus",
          component: (resolve) => require(["@/view/ContactUs"], resolve),
          meta: {
            title: "联系我们",
          },
        },
        {
          path: "/servicedetail",
          name: "servicedetail",
          component: (resolve) => require(["@/view/ServiceDetail"], resolve),
          meta: {
            title: "相关服务",
          },
        },
      ],
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      // 如果 savedPosition 存在，即浏览器的前进后退按钮触发时，直接滚动到之前的位置
      return savedPosition;
    } else {
      // 新的导航，滚动到顶部或者指定的位置
      return { x: 0, y: 0 };
    }
  },
});
// // 使用 `afterEach` 钩子
// Router.afterEach(() => {
//   window.scrollTo(0, 0);
// });

//使用 `scrollBehavior` 选项
// this.$router.beforeEach((to, from, next) => {
//   // 离开当前路由时执行
//   if (from.path !== to.path) {
//     window.scrollTo(0, 0);
//   }
//   next();
// });

// new Vue({
//   Router,
// }).$mount("#app");
// new Vue({
//   Router,
// }).$mount("#app");

// Router.afterEach(() => {
//   window.scrollTo(0, 0);
// });
// const router = new VueRouter({
//   routes,
// });

// new Vue({
//   router,
// }).$mount("#app");



// WEBPACK FOOTER //
// ./src/router/index.js